module.exports = require("scrypt-async");